<template>
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item>
                        <el-select v-model="searchForm.token_status" clearable placeholder="健康币状态">
                            <el-option label="待卖出" value="0"></el-option>
                            <el-option label="已卖出" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchForm.token_out_type" clearable placeholder="健康币卖出类型">
                            <el-option label="主动卖出" value="1"></el-option>
                            <el-option label="系统自动卖出" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchForm.order_status" clearable placeholder="订单状态">
                            <el-option label="待支付" value="0"></el-option>
                            <el-option label="进行中" value="10"></el-option>
                            <el-option label="已取消" value="20"></el-option>
                            <el-option label="已完成" value="30"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                            v-model="searchForm.create_time"
                            size="small"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="searchSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="activity_order_id" label="ID" width="80"></el-table-column>
                <el-table-column prop="activity" label="活动" width="180">
                    <template slot-scope="scope">
                        {{scope.row.activity.title}}
                    </template>
                </el-table-column>
                <el-table-column prop="order_no" label="订单号" width="180"></el-table-column>
                <el-table-column prop="activity_goods_num" label="活动商品数量"></el-table-column>
                <el-table-column prop="batch_no" label="批次序号"></el-table-column>
                <el-table-column prop="user" label="用户">
                    <template slot-scope="scope">
                        {{scope.row.user?scope.row.user.nickName:''}}
                    </template>
                </el-table-column>
                <el-table-column prop="point" label="所得积分"></el-table-column>
                <el-table-column prop="tokens_given" label="健康币数量" width="150"></el-table-column>
                <el-table-column prop="token_value" label="购买时健康币单价" width="150"></el-table-column>
                <el-table-column prop="token_out_value" label="健康币卖出时候的单价" width="150"></el-table-column>
                <el-table-column prop="token_out_time" label="健康币卖出时间"></el-table-column>
                <el-table-column prop="token_status" label="健康币状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.token_status == 0">待卖出</span>
                        <span v-if="scope.row.token_status == 1">已卖出</span>
                    </template>
                </el-table-column>
                <el-table-column prop="token_out_type" label="健康币卖出类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.token_out_type == 1">主动卖出</span>
                        <span v-if="scope.row.token_out_type == 2">系统自动卖出</span>
                    </template>
                </el-table-column>

                <el-table-column prop="status_text" label="订单状态" width="70">
                    <template slot-scope="scope">
                        <span v-if="scope.row.order_status == 0" class="red">待支付</span>
                        <span v-if="scope.row.order_status == 10" class="green">进行中</span>
                        <span v-if="scope.row.order_status == 20" class="yellow">已经取消</span>
                        <span v-if="scope.row.order_status == 30" class="blue">已完成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    export default {
        components: {
        },
        data() {
            return {
                /*表单数据*/
                tableData: [],
                loading: true,
                pageSize: 20,
                totalDataNumber: 0,
                curPage: 1,
                /*横向表单数据模型*/
                searchForm: {
                    token_status: "",
                    token_out_type: '',
                    order_status: '',
                    create_time:''
                },
            };
        },
        created() {
            /*获取平台活动列表*/
            this.getData()
        },
        methods: {
            /*搜索*/
            searchSubmit() {
                this.curPage = 1;
                this.getData();
            },
            /*获取平台活动列表*/
            getData () {
                let self = this
                let Params = self.searchForm
                Params.page = self.curPage
                Params.list_rows = self.pageSize

                self.loading = true
                PlatformActivityApi.order.list(Params, true)
                    .then((data) => {
                        self.loading = false
                        self.tableData = data.data.list.data
                        self.totalDataNumber = data.data.list.total
                    })
                    .catch((error) => {
                        self.loading = false
                    })
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.loading = true;
                this.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.getData();
            },


        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/order/index.vue